module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-BLOG-PLOT-2-0c0782a94ba7afba9d7238a3e58a9eb9.jpeg";